import { Widget, WidgetHeight } from "@arelia-types/widget";
import CustomerLocationsContainer from "./customer-locations/CustomerLocationsContainer";
import CustomersContainer from "./customers/CustomersContainer";
import PlanBreakdownContainer from "./plan-breakdown/PlanBreakdownContainer";
import RevenueContainer from "./revenue/RevenueContainer";

export const hqWidgets: Widget[] = [
  {
    name: "customers",
    id: "CUSTOMERS",
    component: CustomersContainer,
    size: 4,
    height: WidgetHeight.SM,
    page: "/hq",
    tab: "/dashboard",
  },
  {
    name: "revenue",
    id: "REVENUE",
    component: RevenueContainer,
    size: 4,
    height: WidgetHeight.SM,
    page: "/hq",
    tab: "/dashboard",
  },
  {
    name: "customer locations",
    id: "CUSTOMER_LOCATIONS",
    component: CustomerLocationsContainer,
    size: 8,
    height: WidgetHeight.L,
    page: "/hq",
    tab: "/dashboard",
  },
  {
    name: "plan breakdown",
    id: "plan_breakdown",
    component: PlanBreakdownContainer,
    size: 4,
    height: WidgetHeight.M,
    page: "/hq",
    tab: "/dashboard",
  },
];